import React, { useRef } from "react";
import { CSSTransition } from "react-transition-group";
import Portal from "../Portal";

interface AnimatedModalProps {
  className: string;
  visible: boolean;
}

const AnimatedModal: React.FC<AnimatedModalProps> = ({
  children,
  className,
  visible,
}) => {
  const ref = useRef<HTMLElement | null>(null);
  const childRef = useRef<HTMLElement | null>(null);

  return (
    <Portal>
      <CSSTransition
        in={visible}
        timeout={300}
        classNames="fade-y"
        unmountOnExit
        mountOnEnter
        nodeRef={ref}
      >
        <section
          ref={ref}
          className="fixed w-screen h-full z-50 left-0 top-0 bg-blur flex items-center justify-center text-text"
        >
          <CSSTransition
            in={visible}
            timeout={300}
            classNames="fade-expand"
            nodeRef={childRef}
          >
            <section ref={childRef} className={className}>
              {children}
            </section>
          </CSSTransition>
        </section>
      </CSSTransition>
    </Portal>
  );
};

export default AnimatedModal;
